import { PauseCircle } from "lucide-react";
import { useMyLifecycleState } from "@/hooks/useMyLifecycleState";

export function CoachingPausedBanner() {
  const { data: lifecycleData, isLoading } = useMyLifecycleState();

  // Only show for paused state
  if (isLoading || lifecycleData?.lifecycle_state !== "paused") {
    return null;
  }

  return (
    <div className="bg-muted border-b border-border px-5 py-3">
      <div className="flex items-center gap-3 text-muted-foreground">
        <PauseCircle className="h-5 w-5 flex-shrink-0" />
        <p className="text-small">
          Coaching is paused. Your coach will reach out when ready to resume.
        </p>
      </div>
    </div>
  );
}
